import { upperCaseFirstLetter } from './strings';

const removeAccentRegex = /[\u0300-\u036f]/g;
const removePrefixSuffixDashRegex = /^-+|-+$/g;

export const capitalizeFirstLetter = (text: string) => {
  const lowerText = text.toLowerCase();

  return `${lowerText.charAt(0).toUpperCase()}${lowerText.slice(1)}`;
};

export function formatSlugTitle(title: string): string {
  title = title.normalize('NFD').replace(removeAccentRegex, '');
  title = title.toLowerCase();
  title = title.replace(/'/g, '');
  title = title.replace(/[^a-z0-9_]/g, '-');
  title = title.replace(removePrefixSuffixDashRegex, '');
  title = title.replace(/--+/g, '-');

  return title;
}

export const parseUppercaseSnakeTextToCapitalize = (text: string) => {
  return upperCaseFirstLetter(text.replaceAll('_', ' ').toLowerCase());
};

const parser = new DOMParser();

export const parseHtml = (htmlText: string) =>
  parser.parseFromString(htmlText, 'text/html').body.textContent || '';

export const parseUppercaseTextToCapitalize = (text: string) => {
  return upperCaseFirstLetter(text.toLowerCase());
};

export const parseStringToArray = (string: string) => {
  return string.split(',');
};
